import { ImageSourcePropType } from 'react-native'

export const farmerOnboardMiscellaneousAssets: { [name: string]: ImageSourcePropType } = {
  manRaisingHands: require('./man-raising-hands.png'),
  girlOnComputer: require('./girl-on-computer.png'),
  purchasingGroceries: require('./purchasing-groceries.png'),
  backgroundManGardeningWithLadder: require('./background-man-gardening-with-ladder-behind-him.png'),
  farmStoreCauliflowerPhoneCombined: require('./farm-store-cauliflower-phone-combined.png'),
}
